module.exports = __webpack_public_path__ + "img/background.371522a.png";